import Transactions from ".";

export const transactionRoutes = (data) => {
  return [
    {
      path: "/admin/transaction",
      title: "order",
      layout: "admin",
      routeType: "admin",
      component: Transactions,
    },
  ];
};